<script setup lang="ts">
defineProps<{
    name: string
}>()
</script>

<template>
  <span class="resource-menu-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none">
      <!-- Help: mark in a ring -->
      <g v-if="name === 'help'">
        <circle cx="12" cy="12" r="8.25" stroke="currentColor" stroke-width="1.6"/>
        <path d="M9.7 9.5a2.4 2.4 0 1 1 3.6 2.1c-.8.5-1.2 1.1-1.2 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        <path d="M12.1 16.6h.01" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
      </g>
      <!-- Tools: wrench -->
      <g v-else-if="name === 'tools'">
        <path d="M14.7 5.8a3.2 3.2 0 0 0-4.5 4.2L6 14.2 9.8 18l4.2-4.2a3.2 3.2 0 0 0 4.2-4.5l-2.3 2.1-1.6-1.6 2.4-2z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <!-- How it works: play -->
      <g v-else-if="name === 'how-it-works'">
        <rect x="4.25" y="4.25" width="15.5" height="15.5" rx="4" stroke="currentColor" stroke-width="1.6"/>
        <path d="M10 8.8v6.4l5.6-3.2L10 8.8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
      </g>
      <!-- API: brackets -->
      <g v-else-if="name === 'api-docs'">
        <path d="M9 7L5 12l4 5M15 7l4 5-4 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <!-- Reports: bars -->
      <g v-else-if="name === 'reports'">
        <path d="M5 19V11M12 19V6M19 19v-5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
      </g>
      <!-- Guides: book -->
      <g v-else-if="name === 'guides'">
        <path d="M6 6.2A2.2 2.2 0 0 1 8.2 4H19v15.2H8.4A2.4 2.4 0 0 0 6 21.6V6.2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
        <path d="M6 6.2h11.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </g>
      <!-- Case studies: framed image -->
      <g v-else-if="name === 'case-studies'">
        <rect x="4.25" y="5.25" width="15.5" height="13.5" rx="2.4" stroke="currentColor" stroke-width="1.6"/>
        <path d="M4.5 15.2l3.6-3.1 2.6 2.1 3.6-4.4 5.2 5.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <!-- Announcements: megaphone -->
      <g v-else-if="name === 'announcements'">
        <path d="M6.2 10.2v3.6h2.2l6.4 3.4V6.8L8.4 10.2H6.2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
        <path d="M16.8 9.2c.7.6.7 4.9 0 5.6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        <path d="M8.5 13.8v2.2a1.6 1.6 0 0 1-1.6 1.6h-.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </g>
      <!-- Changelog: clock -->
      <g v-else-if="name === 'changelog'">
        <circle cx="12" cy="12" r="7.5" stroke="currentColor" stroke-width="1.6"/>
        <path d="M12 8.2V12l2.8 1.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <!-- MCP: plug -->
      <g v-else-if="name === 'mcp'">
        <path d="M9 7.2v3.2M15 7.2v3.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
        <path d="M8 10.4h8v3.2a4 4 0 0 1-4 4v2.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <!-- Blog: lines -->
      <g v-else>
        <path d="M6 7.5h12M6 12h12M6 16.5h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </g>
    </svg>
  </span>
</template>

<style scoped>
.resource-menu-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    border-radius: 9px;
    color: var(--primary-500);
    background: color-mix(in srgb, var(--primary-500) 10%, transparent);
}

.resource-menu-icon svg {
    width: 18px;
    height: 18px;
}
</style>
